"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["color", "size"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AvatarFilled = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var {
    color,
    size
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("style", null, ".a{fill:none;}.b{fill:#4a4a4a;}")), /*#__PURE__*/_react.default.createElement("defs", null), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(52 312)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    className: "a",
    width: "16",
    height: "16",
    transform: "translate(-52 -312)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "a",
    d: "M-43.993-295.535A2.5,2.5,0,0,1-41.5-298h3a2.5,2.5,0,0,1,2.5,2.465A5.976,5.976,0,0,1-40-294,5.976,5.976,0,0,1-43.993-295.535Zm6.247-6.215A2.25,2.25,0,0,1-40-299.5a2.25,2.25,0,0,1-2.25-2.25A2.25,2.25,0,0,1-40-304,2.25,2.25,0,0,1-37.746-301.75Z",
    transform: "translate(-4.003 -4)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M-37.625-298.535A6.95,6.95,0,0,0-36-303a7,7,0,0,0-7-7,7,7,0,0,0-7,7,6.95,6.95,0,0,0,1.625,4.465l-.01.008c.035.042.075.078.111.12s.093.1.14.15c.14.152.284.3.435.435.046.042.093.081.14.121.16.138.324.268.495.391.022.016.042.035.064.05v-.006A6.973,6.973,0,0,0-43-296a6.973,6.973,0,0,0,4-1.266v.006c.022-.016.042-.034.064-.05.171-.122.334-.253.495-.391.047-.04.094-.08.14-.121.151-.137.295-.283.435-.435.047-.05.1-.1.14-.15s.076-.078.111-.12ZM-43-307a2.25,2.25,0,0,1,2.25,2.25A2.25,2.25,0,0,1-43-302.5a2.25,2.25,0,0,1-2.25-2.25A2.25,2.25,0,0,1-43-307Zm-4,8.465A2.5,2.5,0,0,1-44.5-301h3a2.5,2.5,0,0,1,2.5,2.465A5.976,5.976,0,0,1-43-297,5.976,5.976,0,0,1-47-298.535Z",
    transform: "translate(-1 -1)"
  })));
});
AvatarFilled.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onClick: _propTypes.default.func
};
AvatarFilled.defaultProps = {
  color: 'currentColor',
  size: '1em',
  onClick: () => {}
};
var _default = AvatarFilled;
exports.default = _default;